function initCartPlaceholders() {
  document.querySelectorAll('.cart-item__media').forEach((container) => {
    if (!container.querySelector('img')) {
      container.classList.add('cart-item__media--no-image');
    }
  });
}

initCartPlaceholders();

// Reinit on cart updates
document.addEventListener('cart:update', initCartPlaceholders);
